import { render } from "./I_SendField.vue?vue&type=template&id=08474eb7"
import script from "./I_SendField.vue?vue&type=script&lang=js"
export * from "./I_SendField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__